// ============================================================================
// PORTUGUESE TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Esclarecimentos sobre quem Jesus é (e quem ele não é)

export const jesusIsNot = [
  {
    category: "amor",
    text: "Jesus não é racista - Ele ama a todos igualmente, independentemente de sua origem",
    reference: "João 4:9 - A mulher samaritana se admira de que Jesus lhe fale",
    context: "Jesus rompe as barreiras culturais e raciais de sua época"
  },
  {
    category: "exclusão",
    text: "Jesus não é excludente - Ele acolhe a todos, especialmente os marginalizados",
    reference: "Mateus 9:10-13 - Jesus come com publicanos e pecadores",
    context: "Jesus busca os perdidos e rejeitados da sociedade"
  },
  {
    category: "julgamento",
    text: "Jesus não é condenador - Ele veio para salvar, não para condenar",
    reference: "João 3:17 - Deus não enviou seu Filho para condenar o mundo",
    context: "A missão de Jesus é a salvação e a restauração"
  },
  {
    category: "violência",
    text: "Jesus não é violento - Ele ensina o amor aos inimigos",
    reference: "Mateus 5:44 - Amai os vossos inimigos",
    context: "Jesus revoluciona o conceito de justiça com o amor radical"
  },
  {
    category: "riqueza",
    text: "Jesus não é materialista - Ele adverte contra o amor ao dinheiro",
    reference: "Mateus 6:24 - Não podeis servir a Deus e às riquezas",
    context: "Jesus prioriza os tesouros celestiais sobre os terrenos"
  },
  {
    category: "orgulho",
    text: "Jesus não é orgulhoso - Ele se humilha e serve",
    reference: "João 13:5 - Jesus lava os pés de seus discípulos",
    context: "Jesus mostra que a grandeza está no serviço humilde"
  },
  {
    category: "legalismo",
    text: "Jesus não é legalista - Ele coloca a misericórdia acima do ritual",
    reference: "Mateus 12:7 - Misericórdia quero e não sacrifício",
    context: "Jesus critica o legalismo que esquece o coração da lei"
  },
  {
    category: "gênero",
    text: "Jesus não é sexista - Ele honra e valoriza as mulheres",
    reference: "João 4:27 - Os discípulos se admiram de que ele fale com uma mulher",
    context: "Jesus desafia as normas patriarcais de sua cultura"
  },
  {
    category: "poder",
    text: "Jesus não é tirano - Ele lidera com amor e exemplo",
    reference: "Mateus 20:28 - O Filho do Homem veio para servir",
    context: "Jesus redefine a liderança como serviço sacrificial"
  },
  {
    category: "vingança",
    text: "Jesus não é vingativo - Ele perdoa e restaura",
    reference: "Lucas 23:34 - Pai, perdoa-lhes, porque não sabem o que fazem",
    context: "Jesus pratica o perdão radical mesmo na cruz"
  },
  {
    category: "indiferença",
    text: "Jesus não é indiferente - Ele se comove diante do sofrimento",
    reference: "Mateus 9:36 - Teve compaixão das multidões",
    context: "Jesus mostra empatia profunda pelos que sofrem"
  },
  {
    category: "elite",
    text: "Jesus não é elitista - Ele se cerca de gente comum",
    reference: "Marcos 1:16-20 - Jesus chama pescadores como discípulos",
    context: "Jesus escolhe pessoas ordinárias para sua missão extraordinária"
  },
  {
    category: "hipocrisia",
    text: "Jesus não é hipócrita - Ele vive o que ensina",
    reference: "João 8:46 - Quem dentre vós me convence de pecado?",
    context: "Jesus desafia a encontrar contradição entre suas palavras e ações"
  },
  {
    category: "rigidez",
    text: "Jesus não é rígido - Ele adapta seu ensinamento a cada pessoa",
    reference: "João 3 - Jesus fala diferente com Nicodemos do que com a samaritana",
    context: "Jesus personaliza sua mensagem conforme as necessidades de cada um"
  },
  {
    category: "tradição",
    text: "Jesus não é tradicionalista cego - Ele questiona tradições que oprimem",
    reference: "Marcos 7:13 - Invalidando a palavra de Deus com vossa tradição",
    context: "Jesus prioriza o espírito da lei sobre as tradições humanas"
  },
  {
    category: "nacionalismo",
    text: "Jesus não é nacionalista - Seu reino transcende fronteiras",
    reference: "Mateus 28:19 - Ide e fazei discípulos de todas as nações",
    context: "A missão de Jesus é universal, não limitada a um só povo"
  },
  {
    category: "divisão",
    text: "Jesus não é divisivo - Ele ora pela unidade dos crentes",
    reference: "João 17:21 - Para que todos sejam um",
    context: "Celebremos nossas diversidades em vez de criar guerras de palavras"
  },
  {
    category: "verdade",
    text: "Jesus não é mentiroso - Ele denuncia a mentira e a manipulação",
    reference: "João 8:44 - O diabo é pai da mentira",
    context: "Jesus expõe as mentiras e manipulações que ferem as almas"
  },
  {
    category: "generosidade",
    text: "Jesus não é avarento - Sua generosidade supera amplamente o dízimo",
    reference: "Lucas 21:3 - Esta viúva pobre deu mais do que todos",
    context: "A generosidade de Jesus é mais forte que a obrigação do dízimo"
  },
  {
    category: "justiça",
    text: "Jesus não é cúmplice do silêncio - Ele protege com uma justiça saudável",
    reference: "Mateus 18:6 - Quem fizer tropeçar um destes pequeninos",
    context: "O silêncio que encobre faltas sem proteger outros não é a sabedoria de Jesus"
  }
];

export default jesusIsNot;
